<template>
  <main class="preisvorteile-sichern">
    <CouponCheck
      teaser-heading="Jetzt Preisvorteile Sichern!"
      teaser-copy="Löse Gutscheine und Coupons direkt hier ein und sichere Dir aktuelle Preisvorteile. Entdecke außerdem unsere aktuellen Gutschein-Aktionen."
      tag-title="h3"
      large
    />

    <section
      v-if="teasersContent.length > 0"
      class="preisvorteile-sichern__teasers"
    >
      <Heading
        text-uppercase
        size="md"
        font-weight="ultra"
        align="center"
        tag="h2"
      >
        Aktuelle Aktionen
      </Heading>
      <Paragraph
        align="center"
        class="preisvorteile-sichern__teasers-paragraph"
      >
        Nutze unsere aktuellen Aktions-Angebote und sichere Dir tolle Preisvorteile!
      </Paragraph>
      <PromotionTiles
        :promotions="teasersContent"
        heading-tag="h3"
      />
    </section>

    <DiscountedOffers tag-title="h3" />
  </main>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { Heading, Paragraph } from '@i22-td-smarthome/component-library';
import { getHeader } from '~/helpers/page-header-compositon';
import { Track } from '~/helpers/page-tracking';

import CouponCheck from '~/components/treueshop/coupon-check.vue';
import DiscountedOffers from '~/components/treueshop/discounted-offers.vue';

import PromotionTiles from '~/components/promotion-tiles.vue';
import { type Promotion } from '~/components/promotion-tile.vue';

const teasersContent: Promotion[] = [];

Track();

getHeader({
  title: ref('Gutscheine & Coupons einlösen'),
  description: ref(
    'Profitiere von aktuellen Rabatt-Aktionen und löse Gutscheine & Coupons bequem online ein. Jetzt entdecken und Preisvorteile sichern!'
  ),
});
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.preisvorteile-sichern {
  max-width: $mq-lpg-lg;
  width: 100%;
  margin: 0 auto;
  padding-top: $grid-base;

  @include mq($mq-md) {
    padding-top: 3 * $grid-base;
  }

  &__results {
    margin-bottom: 3 * $grid-base;
  }

  &__teasers {
    margin-bottom: 5 * $grid-base;
    &-paragraph {
      margin-bottom: 2 * $grid-base;
    }
  }

  :deep(.offer-tiles) {
    --offer-grid-columns-sm: 2;
  }

  &__pagination {
    position: relative;
    margin-top: 2 * $grid-base;

    :deep(.pagination) {
      margin-bottom: $grid-base;
    }

    &-size-toggle {
      margin-left: $grid-base;

      @include mq($mq-md) {
        position: absolute;
        right: $grid-base;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  :deep(.promotion-tiles) {
    justify-content: flex-start;
  }
}
</style>
